export default "__VITE_ASSET__f2bb155e__"